<!--  是否選擇 -->
<template>
  <div>
    <v-btn-toggle v-model="innerValue"
                  @change="changeHandler"
                  :class="{'error-border':error}"
                  :mandatory="isClick">

      <template v-for="(item, index) in items">
        <v-btn :value="item.value"
               :style="(items.length==1)?'border-radius: 8px 8px 8px 8px;':''"
               @click="btnClick"
               :key="`${item.value}_${index}`"
               :disabled="disabled">
          {{item.text}}
        </v-btn>
      </template>
    </v-btn-toggle>
    <v-messages v-if="errorMessages"
                :value="errorMessages"
                color="error"
                class="mt-2"></v-messages>
  </div>
</template>
<script>
export default {
  name: 'base-yn',

  props: {
    value: [String, Number],
    disabled: {
      type: Boolean,
      default: false
    },
    errorMessages: [String, Array],
    error: Boolean,
    items: {
      type: Array,
      default: function () {
        return [
          {
            text: '是',
            value: 'Y'
          },
          {
            text: '否',
            value: 'N'
          }
        ]
      }
    }
  },

  data () {
    return {
      innerValue: null
    }
  },

  computed: {
    isClick () {
      return !!this.innerValue
    },
    secondValue () {
      const { items } = this
      const [, second] = items
      return second.value
    }
  },

  watch: {
    // Handles external model changes.
    value: {
      handler (newVal) {
        // this.innerValue = newVal
        if (newVal) {
          if (typeof newVal === 'string') {
            this.innerValue = newVal.trim()
          } else {
            this.innerValue = newVal
          }
        } else {
          this.innerValue = newVal
        }
      }
    }
  },

  created () {
    if (this.value) {
      // this.innerValue = this.value
      if (typeof newVal === 'string') {
        this.innerValue = this.value.trim()
      } else {
        this.innerValue = this.value
      }
    }
  },

  methods: {
    secondBtnHandler () {
      this.innerValue = this.secondValue
      this.changeHandler(this.innerValue)
    },
    changeHandler (v) {
      this.$emit('input', v)
      this.$el.dispatchEvent(new CustomEvent('change', { bubbles: true }))
    },
    btnClick () {
      if (this.items.length === 1) {
        if (this.innerValue) {
          this.innerValue = ''
          this.changeHandler('')
        }
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-btn-toggle {
  width: 100%;
  border-radius: 8px;
}

.v-btn-toggle:not(.v-btn-toggle--selected) {
  border: 1px solid #eee;
}

.v-btn--active {
  background-color: $primary-color !important;
  color: #fff !important;
}

.v-btn-toggle .v-btn:first-child {
  border-radius: 8px 0 0 8px;
  border: 1px solid $gray;
}

.v-btn-toggle .v-btn:last-child {
  border-radius: 0 8px 8px 0;
  border: 1px solid $gray;
}

.v-btn-toggle {
  .v-btn {
    border: 1px solid $gray;
    height: $height;
    min-width: auto !important;
  }
}
</style>
